
import * as wish from './staticData/wish';
import {helptype} from './staticData/myNeighbor';


export const localDataCore = {
    ...wish,
    helptype,
    /**
     * 
     */
    // insertAllData(data: Array<any>): Array<any> {
    //     const rsult = [{ id: '', name: '全部' }].concat(data);
    //     return rsult;
    // }
}

